import React from 'react';
import PropTypes from 'prop-types';

const TrackTitle = ({ title, trackColor }) => (
    <div className="column is-desktop" key={title}>
        <i className={`fas fa-circle ${trackColor}`} />
        <h2 className="subtitle track-title">{title}</h2>
    </div>
);

TrackTitle.propTypes = {
    title: PropTypes.string.isRequired,
    trackColor: PropTypes.string.isRequired
};

export default TrackTitle;
